import { useGameState } from '../../../net/GameProvider.js';
import { useI18n } from '../../../i18n.js';

interface TurnIndicatorProps {
  isMyTurn: boolean;
  timeLeft: number | null;
  cannotBeat?: boolean;
  customPrompt?: string;
}

export function TurnIndicator({ isMyTurn, timeLeft, cannotBeat, customPrompt }: TurnIndicatorProps) {
  const { state } = useGameState();
  const { t } = useI18n();
  const { game } = state;

  if (!game || (!game.activePlayerId && !customPrompt) || timeLeft === null) return null;
  const isPaused = game.pause?.status === 'paused';
  if (isPaused) return null;

  const isRequestingPause = game.pause?.status === 'requesting';
  const activePlayerName = game.players.find((p) => p.playerId === game.activePlayerId)?.name ?? '';

  const badgeText = customPrompt
    ? customPrompt
    : isMyTurn
    ? cannotBeat
      ? `⚠️ ${t.cannotBeatTrickPrompt}`
      : `🎯 ${t.yourTurn}`
    : `⏳ ${t.waitingForTurn(activePlayerName)}`;

  return (
    <div
      className={`center-turn-indicator${isMyTurn ? ' is-my-turn' : ' is-opponent-turn'}${
        cannotBeat ? ' is-cannot-beat' : ''
      }`}
    >
      <div className="turn-indicator-pill">
        <span className="turn-indicator-badge">{badgeText}</span>
        <span className={`turn-indicator-timer${timeLeft <= 5000 ? ' is-urgent' : ''}`}>
          ⏱️ {Math.ceil(timeLeft / 1000)}s
        </span>
      </div>

      {/* Linear Progress Timer */}
      <div className="turn-timer-track">
        <div
          className="turn-timer-fill"
          style={{
            background:
              timeLeft < 5000
                ? 'var(--danger-color)'
                : cannotBeat
                ? '#f59e0b'
                : isRequestingPause
                ? '#fbbf24'
                : isMyTurn
                ? '#34d399'
                : 'var(--accent-color)',
            width: `${Math.max(0, Math.min(100, (timeLeft / (game.turnDurationMs ?? 30000)) * 100))}%`,
            transition: 'width 0.1s linear, background 0.3s',
          }}
        />
      </div>
    </div>
  );
}
